// extracted by mini-css-extract-plugin
module.exports = {"container":"privacy-settings_container__2WosC","privacyPolicy":"privacy-settings_privacyPolicy__2WUjj"};